import { $ } from '../utils/dom.js';
import { state, rowSignature } from '../state.js';

let renderCb = null;
let buildStatusChipsCb = null;
let applyFiltersCb = null;

export function bindHeaderRender(opts) {
  renderCb = opts.render;
  buildStatusChipsCb = opts.buildStatusChips;
  applyFiltersCb = opts.applyFilters;
}

export function setLiveDot(mode) {
  const d = $('liveDot');
  if (!d) return;
  d.className = 'live-dot ' + mode;
  const labels = { live: 'En vivo', loading: 'Actualizando…', error: 'Sin conexión' };
  const lbl = $('liveLabel');
  if (lbl) lbl.textContent = labels[mode] || '';
}

export function flashLive() {
  const d = $('liveDot');
  if (!d) return;
  d.classList.remove('flash');
  void d.offsetWidth;
  d.classList.add('flash');
}

export function afterLoad(silent) {
  $('status').style.display = 'none';
  $('app').style.display = '';
  $('lastUpdate').textContent = 'Actualizado: ' + new Date().toLocaleString('es-MX');

  const sig = rowSignature();
  const changed = sig !== state.lastSignature;
  state.lastSignature = sig;

  if (silent && !changed) {
    setLiveDot('live');
    return;
  }

  if (silent) flashLive();

  if (state.firstLoad) {
    state.firstLoad = false;
    buildStatusChipsCb && buildStatusChipsCb();
    applyFiltersCb && applyFiltersCb();
  } else {
    buildStatusChipsCb && buildStatusChipsCb();
    applyFiltersCb && applyFiltersCb(true);
  }
  setLiveDot('live');
}
